module.exports = __webpack_public_path__ + "static/media/rekontrukce-hruba-stavba.cf741ecc.jpg";